
/**
 * api接口统一管理
 */
import {axiosInstance} from "@/api/http";

export const getClassifyGrade = params => axiosInstance.get('/education-api/course/classify-grade',{params})


/**
 * 分页-课程列表查询
 * @param obj
 */
export const getPageList = params => axiosInstance.get('/education-api/course/page-list',{params})

/**
 * 根据课程id-查询详情
 * @param obj
 */
export const getDetail = id => axiosInstance.get('/education-api/course/detail/'+id)

/**
 * 我的课程
 * @param obj
 */
export const getMyList = params => axiosInstance.get('/education-api/course/myCourse',{params})

/**
 * 节学习记录
 * @param obj
 */
export const sectionRecordSubmit = data => axiosInstance.post('/education-api/course/section-record/submit/',data)

